export const setCustomInterval = (handler: () => void, timeout: number) => {
  const intervalId = window.setInterval(handler, timeout);

  return () => {
    window.clearInterval(intervalId);
  };
};
